import { HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { Application } from '../models/application';
import { withStatusMessage } from '@app/core/services/status-message-interceptor';
import { ApiStatusTransitions } from '@app/shared/models/api-status-transitions';
import { StatusTransition } from '@app/shared/models/status-transition';
import { ApiBase } from '@app/shared/models/api-base';
import { ApiGet } from '@app/shared/models/api-get';
import { ApiGetById } from '@app/shared/models/api-get-by-id';
import { ApiSetStatus } from '@app/shared/models/api-set-status';
import { ApiGetExport } from '@app/shared/models/api-get-export';

@Injectable({
  providedIn: 'root',
})
export class ApplicationApi
  extends ApiBase
  implements
    ApiGet<Application>,
    ApiGetById<Application>,
    ApiSetStatus,
    ApiStatusTransitions,
    ApiGetExport
{
  override endpoint = 'applications';

  get(params?: HttpParams, context?: HttpContext): Observable<Application[]> {
    return this.httpClient.get<Application[]>(this.url(), {
      params: params,
      context: context ? context : withStatusMessage(true, false),
    });
  }

  getById(
    id: number,
    params?: HttpParams,
    context?: HttpContext
  ): Observable<Application> {
    return this.httpClient.get<Application>(`${this.url()}/${id}`, {
      params: params,
      context: context ? context : withStatusMessage(true, false),
    });
  }

  getLastCompanyOwn(
    params?: HttpParams,
    context?: HttpContext
  ): Observable<Application> {
    return this.httpClient.get<Application>(
      `${environment.apiUrl}/companies/own/application`,
      {
        params: params,
        context: context ? context : withStatusMessage(true, false),
      }
    );
  }

  setStatus(
    id: number,
    status: string,
    body?: FormData,
    context?: HttpContext
  ): Observable<unknown> {
    return this.httpClient.post<Application>(
      `${this.url()}/${id}/${status}`,
      body,
      {
        context: context ? context : withStatusMessage(),
      }
    );
  }

  getAllStatusTransitions(id: number): Observable<StatusTransition[]> {
    return this.httpClient.get<StatusTransition[]>(
      `${this.url()}/${id}/status-transitions`
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getOwnStatusTransitions(id: number): Observable<StatusTransition[]> {
    return this.httpClient.get<StatusTransition[]>(
      `${environment.apiUrl}/companies/own/application/status-transitions`
    );
  }

  getExport(params?: HttpParams, context?: HttpContext): Observable<Blob> {
    return this.httpClient.get(`${this.url()}/csv`, {
      responseType: 'blob',
      params: params,
      context: context ? context : withStatusMessage(true, false),
    });
  }
}
